<script setup lang="ts">
import { PlusIcon } from "@heroicons/vue/24/outline";
</script>

<template>
  <button
    class="flex items-center justify-center rounded cursor-pointer w-7 h-7 hover:bg-slate-100 border-slate-500 text-slate-500 bg-slate-50 focus:outline-none focus:ring-2 ring-offset-slate-500 ring-offset-2 ring-slate-200"
    type="button"
  >
    <PlusIcon class="w-6 h-6" />
  </button>
</template>
